/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import cn from "classnames";
import styles from "gui/entries/entries.module.css";
import { DashboardEntry } from "gui/entries/dashboard-entry";
import { EntryDashboard } from "lib/entries/types";

interface Props {
  entries: EntryDashboard[];
  color1?: boolean;
  color2?: boolean;
  avatar?: boolean;
  favorites?: boolean;
}

export const DashboardList: React.FC<Props> = (props) => {
  const className = cn(
    styles.list,
    props.color1 && styles.color1,
    props.color2 && styles.color2
  );

  return (
    <ul className={className}>
      {props.entries.map((entry) => (
        <DashboardEntry
          key={entry.id}
          entry={entry}
          color1={props.color1}
          avatar={props.avatar}
          favorites={props.favorites}
        />
      ))}
    </ul>
  );
};
